import type { FC, HTMLProps } from "react";

import classnames from "classnames";

import { Column, Row } from "@jti/core-components/components/Row";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import { BackToCartButton } from "@checkout-v2/shared/components/BackToCartButton";

import styles from "./PageHeader.module.scss";

type PageHeaderProps = {
  pageTitle: string;
  itemsCount?: number;
} & HTMLProps<HTMLDivElement>;

export const PageHeader: FC<PageHeaderProps> = ({ pageTitle, itemsCount, className, ...restProps }) => {
  const { __ } = useTranslations();

  return (
    <header className={classnames(styles.container, className)} {...restProps}>
      <Row>
        <Column>
          <BackToCartButton />
        </Column>
      </Row>

      <Row className={styles.titleRow} data-testid="page-header-title-row">
        <Column md={9} className={styles.titleColumn}>
          <h1 className={styles.pageTitle}>{pageTitle}</h1>
        </Column>
        <Column md={3} className={styles.itemsCountColumn}>
          {itemsCount ? <span className={styles.itemsCount}>{__("checkout.items_count", [itemsCount])}</span> : null}
        </Column>
      </Row>
    </header>
  );
};
